import cn from 'clsx'
import s from './DetailDropdowns.module.scss'
import { Text, useUI } from '@components/ui'
import * as Accordion from '@radix-ui/react-accordion'
import { LoreThreeDetailPageSectionsInnerDropdownsInner } from '@generated/model/loreThreeDetailPageSectionsInnerDropdownsInner'
import { CirclePlus } from '@components/icons'

type DetailDropdownsProps = {
  dropdowns: LoreThreeDetailPageSectionsInnerDropdownsInner[]
  handleSetActiveDropdown: (index: number) => void
}

const DetailDropdowns = ({
  dropdowns,
  handleSetActiveDropdown,
}: DetailDropdownsProps) => {
  return (
    <>
      <div className={cn(s.root)}>
        <div className={s.contentContainer}>
          <div className={s.questions}>
            <Accordion.Root
              type="single"
              collapsible
              defaultValue={dropdowns?.length > 0 ? 'dropdown_0' : undefined}
              onValueChange={(value) => {
                if (value) {
                  const index = parseInt(value.split('_')[1])
                  handleSetActiveDropdown(index)
                }
              }}
              className={s.AccordionRoot}
            >
              {dropdowns &&
                dropdowns.map((dropdown, index: number) => (
                  <Accordion.Item
                    className={cn(s.dropdown, s.AccordionItem)}
                    key={`dropdown_${index}`}
                    value={`dropdown_${index}`}
                  >
                    <Accordion.Header className={s.AccordionHeader}>
                      <Accordion.Trigger className={s.AccordionTrigger}>
                        <CirclePlus fillColor={'var(--page-color)'} />
                        <Text
                          html={dropdown.title}
                          className={s.dropdownTitle}
                          variant="smallText"
                        />
                      </Accordion.Trigger>
                    </Accordion.Header>
                    <Accordion.Content className={s.AccordionContent}>
                      <Text
                        html={dropdown.detail}
                        className={s.detail}
                        variant="smallText"
                      />
                    </Accordion.Content>
                  </Accordion.Item>
                ))}
            </Accordion.Root>
          </div>
        </div>
      </div>
    </>
  )
}

export default DetailDropdowns
